import React from "react";
import Circle1 from "../../../assets/images/Circle1.svg";
import Circle2 from "../../../assets/images/Circle2.svg";
import Button from "../../../components/Button/Button";
import logo from "../../../assets/images/admin.svg";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { Link } from "react-router-dom";
import styles from "./signUp.module.css";

const ForgotPassword = () => {
  return (
    <div className={styles.signupcontainer}>
      <div className={styles.forsignup}>
        <div className={styles.container}>
          <div className={`${styles.SecondCircle}`}>
            <img src={Circle2} alt="" />
          </div>
          <div className={`${styles.FirstCircle}`}>
            <img src={Circle1} alt="" />
          </div>
          <div className={`${styles.Random}`}>
            <img src={logo} alt="logo" className="auth-logo" />
          </div>
          <div className={`${styles.maincontainer} auth-form`}>
            <React.Fragment>
              <div className="auth-heading">Forgot Password</div>
              <div className="input-group-styling">
                <InputGroup
                  label="Email Address"
                  // inputValue={email}
                  margin="normal"
                  inputName="email"
                  placeHolder="Email Adress"
                  inputType="email"
                />
              </div>
              <div className={`${styles.Footer1}auth-form-buttons input-padding`}>
                <Link to="/auth/reset-password">
                  <Button buttonName="Forgot Password" variant="primary" buttonSize="full"
                    color="btndefault"
                  />
                </Link>
              </div>
            </React.Fragment>
            <div className={`${styles.Footer2} auth-account-button input-group-styling input-padding`}>
              Remember Password ?
              <Link to="/auth/signup" className="">Go to Login</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
